/**
 * PendingPBCancelScreen — Pending Party Bill Cancel (4.21.4)
 * A list-only action screen: shows Party Bills still in "Pending" status (not yet
 * invoiced/received) and lets the user Cancel one via the row action column.
 */
import React, { useState, useEffect, useCallback } from 'react';
import ERPAdvancedGrid from '../../../components/erp/ERPAdvancedGrid';
import { erpToast } from '../../../components/erp/ERPToast';
import '../../../styles/erp-theme.css';
import { fmtN, getSessionPartyBills, updateSessionPartyBill } from './usePartyBillMasters';

const COLUMNS = [
  { field: 'pbNo', header: 'PB No' },
  { field: 'pbDate', header: 'PB Date' },
  { field: 'supplierName', header: 'Supplier' },
  { field: 'refNo', header: 'Ref No' },
  { field: 'netAmount', header: 'Net Amount' },
  { field: 'status', header: 'Status' },
];

const PendingPBCancelScreen = ({ theme = 'light' }) => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [filters, setFilters] = useState({});

  const refresh = useCallback(() => {
    setRows(getSessionPartyBills().filter(pb => pb.status === 'Pending'));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const handleCancel = (row) => {
    if (!window.confirm(`Cancel Party Bill ${row.pbNo}? This cannot be undone.`)) return;
    updateSessionPartyBill(row.pbNo, { status: 'Cancelled' });
    erpToast.success(`Party Bill ${row.pbNo} cancelled`);
    refresh();
  };

  const filtered = rows.filter(r => Object.entries(filters).every(([k, v]) => !v || String(r[k] || '').toLowerCase().includes(v.toLowerCase())));

  return (
    <div className="erp-module" data-testid="pending-pb-cancel-screen" data-dev-component="PendingPBCancelScreen" data-dev-file="screens/procurement/party-bill/PendingPBCancelScreen.js">
      <ERPAdvancedGrid
        title="Pending PB Cancel"
        columns={COLUMNS}
        data={filtered.slice((page - 1) * pageSize, page * pageSize)}
        total={filtered.length}
        idField="pbNo"
        nameField="supplierName"
        page={page}
        pageSize={pageSize}
        onPageChange={setPage}
        onPageSizeChange={(s) => { setPageSize(s); setPage(1); }}
        filters={filters}
        onFilterChange={(f) => { setFilters(f); setPage(1); }}
        loading={false}
        showAddNew={false}
        onVoid={handleCancel}
        testId="pending-pb-cancel-grid"
        cellRenderer={(field, value) => (field === 'netAmount' ? <span style={{ fontFamily: 'var(--erp-font-mono)' }}>{fmtN(value)}</span> : null)}
      />
    </div>
  );
};

export default PendingPBCancelScreen;
